export interface KPIOption {
  isActive: boolean;
  date: Record<string, boolean>;
  segment?: Record<string, boolean>;
  comparison?: Record<string, boolean>;
}

export interface IKpiSettingsBase {
    segments: string[];
    comparison: string[];
}

export type KpiSettingsWithoutDate = IKpiSettingsBase;

export type StayDateConfig = { 
    type: 'day' | 'week' | 'month'; 
    value: number | null; 
};

export type KpiSettingsDynamic = KpiSettingsWithoutDate & {
    [key: string]: any;
};

export type ConfigurationPreset = {
    name: string;
    date: string | null;
    kpiSettings: Record<string, KpiSettingsDynamic>;
    stayDate: StayDateConfig;
};

export type State = {
    savedConfigurations: Record<string, ConfigurationPreset>;
    selectedConfigId: string;
    editingPresetDate: string | null;
    editingKPIKey: string | null;
    editingKPI: KpiSettingsDynamic;
    initialConfigurationsLoaded: boolean;
    sharedStayDate: StayDateConfig; 
};

export const ActionType = {
  INIT: "INIT",
  SELECT_PRESET: "SELECT_PRESET",
  SELECT_KPI: "SELECT_KPI",
  UPDATE_EDITING_KPI: "UPDATE_EDITING_KPI",
  UPDATE_PRESET_DATE: "UPDATE_PRESET_DATE",
  APPLY_KPI_CHANGES: "APPLY_KPI_CHANGES",
  SAVE_PRESET: "SAVE_PRESET",
  NEW_PRESET: "NEW_PRESET",
  DELETE_PRESET: "DELETE_PRESET",
  REMOVE_KPI_FROM_PRESET: "REMOVE_KPI_FROM_PRESET",
  UPDATE_SHARED_STAY_DATE: "UPDATE_SHARED_STAY_DATE",
  APPLY_STAY_DATE_CHANGES: "APPLY_STAY_DATE_CHANGES",
} as const;

export type Action =
  | { type: typeof ActionType.INIT; savedPresets: Record<string, ConfigurationPreset>; firstKPI: string | null; initialStayDate: StayDateConfig }
  | { type: typeof ActionType.SELECT_PRESET; id: string; preset: ConfigurationPreset }
  | { type: typeof ActionType.SELECT_KPI; key: string; config: KpiSettingsDynamic }
  | { type: typeof ActionType.UPDATE_EDITING_KPI; updates: Partial<KpiSettingsDynamic> }
  | { type: typeof ActionType.UPDATE_PRESET_DATE; date: string | null }
  | { type: typeof ActionType.APPLY_KPI_CHANGES; currentKPISettings: KPIOption }
  | { type: typeof ActionType.SAVE_PRESET; name: string }
  | { type: typeof ActionType.NEW_PRESET; id: string; preset: ConfigurationPreset }
  | { type: typeof ActionType.DELETE_PRESET; id: string }
  | { type: typeof ActionType.REMOVE_KPI_FROM_PRESET; key: string }
  | { type: typeof ActionType.UPDATE_SHARED_STAY_DATE; stayDate: StayDateConfig }
  | { type: typeof ActionType.APPLY_STAY_DATE_CHANGES; stayDate: StayDateConfig };

export const INITIAL_CONFIG_ID = "default-1";
export const INITIAL_KPI_SETTINGS: KpiSettingsDynamic = { segments: [], comparison: [] };
export const INITIAL_STAY_DATE: StayDateConfig = { type: 'day', value: 1 };